._dashboard-shortcut-wrapper_1mr2v_1 {
  height: 100%;
  display: block; }
